import { render } from "./exam-list.vue?vue&type=template&id=7a5af933&scoped=true"
import script from "./exam-list.js?vue&type=script&lang=js&external"
export * from "./exam-list.js?vue&type=script&lang=js&external"

import "./exam-list.scss?vue&type=style&index=0&id=7a5af933&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5af933"]])

export default __exports__